import { useEffect, useRef } from "react";

const CLIENT = "ca-pub-1159707192196403";
const SLOT = "4292688479";

export const AdUnit = ({ className = "", testId = "ad-unit" }) => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el || el.getAttribute("data-adsbygoogle-status")) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch {}
  }, []);

  return (
    <div data-testid={testId} className={`max-w-[1400px] mx-auto px-5 sm:px-8 ${className}`}>
      <div className="border border-white/[0.06] bg-[#0F0D16]/60 p-3">
        <span className="kp-eyebrow !text-[0.5rem] !text-[#64748B] block mb-2">Advertisement</span>
        <ins
          ref={ref}
          className="adsbygoogle"
          style={{ display: "block", minHeight: 100 }}
          data-ad-client={CLIENT}
          data-ad-slot={SLOT}
          data-ad-format="auto"
          data-full-width-responsive="true"
        />
      </div>
    </div>
  );
};
